import { z } from 'zod';

export const $s = z.string();
export const $n = z.number();
export const $b = z.boolean();

/** zod.literal() shorthand*/
export const $l = z.literal;
export const $enum = z.enum;

/**
 * Our API timestamps are not in ISO format. Close, but not quite.
 */
export const $bareDate = z
    .string()
    .refine((value) => /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(:\d{2}(\.\d+)?)?$/.test(value), {
        message: 'timestamp must be of the unqualified form yyyy-mm-ddThh:mm[:ss[.mmm]]'
    });

/**
 * Create type assertion, e.g.
 *
 *     const isImmanentEschaton = makeAssertion(ImmanentEschatonSchema)
 */
export const makeAssertion =
    <S extends z.ZodType>(schema: S) =>
    (t: any): t is S extends z.ZodType<infer T> ? T : never =>
        schema.safeParse(t).success;
